import type { BillingFeature } from "@polifonia/interlude/billingConstants";
import { useGateValue } from "@statsig/react-bindings";
import { useMemo } from "react";

export const useEnableAiAgentConversationMetering = (): boolean => {
  return useGateValue("enable_ai_agent_conversation_metering");
};

/**
 * AI agent meter features hidden from the Admin Center under the current rollout
 * flag: ai_agent_message once ai_agent_conversation is live, otherwise
 * ai_agent_conversation while it is not surfaced yet. Returned as a set so the
 * rule stays generic if more features join the cutover.
 */
export const useInactiveAiAgentFeatures = (): ReadonlySet<BillingFeature> => {
  const enableConversationMetering = useEnableAiAgentConversationMetering();
  return useMemo(
    () =>
      new Set<BillingFeature>([
        enableConversationMetering
          ? "ai_agent_message"
          : "ai_agent_conversation",
      ]),
    [enableConversationMetering],
  );
};
